import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter } from "react-router";
import { RouterProvider } from "react-router/dom";

import "@fontsource-variable/geist";
import "@fontsource-variable/geist-mono";
import "./styles.css";

import { raiCoreClient } from "@rai/core/services/raicore-client";
import { installImpersonationHeader } from "@/services/customer-portal/impersonation";
import { Root } from "./root";
import { RouteError } from "./route-error";
import { routes } from "./routes";

// A tab acting as a Rai Managed business sends its token on customer calls.
installImpersonationHeader(raiCoreClient);

const router = createBrowserRouter([{ Component: Root, ErrorBoundary: RouteError, children: routes }]);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
